import StudentVocabularyActivityApi from './StudentVocabularyActivityApi';
export default StudentVocabularyActivityApi;
